export const SHOW_MAINTENANCE_MODAL = 'showMaintenanceModal';
export const HIDE_MAINTENANCE_MODAL = 'hideMaintenanceModal';
export const REMOVE_CURRENT_USER = 'removeCurrentUser';
export const FETCH_CURRENT_USER = 'fetchCurrentUser';
export const SET_TOAST = 'setToast';
